import RemotesList from "./RemotesList";
import RemoteView from "./RemoteView";
import UniversalRemotes from "./UniversalRemotes";
import SelectBlaster from "./SelectBlaster";
import ChooseCategory from "./ChooseCategory";
import ChooseBrand from "./ChooseBrand";
import TestRemote from "./TestRemote";
import { REMOTE_PATHS } from "./remoteUtils";

export { REMOTE_PATHS };

// IR blaster pages. Both read the IRBM device from the location state:
// /remotes { data: device }, /remote { data: device, remote: device.remoteDevices[i] }.
// Universal Remotes (the app's HashhRemoteStack) lists every remote in the
// home, and its add-remote steps go blaster, category, brand, then test.
export const REMOTE_ROUTES = [
  { path: REMOTE_PATHS.LIST, component: RemotesList },
  { path: REMOTE_PATHS.VIEW, component: RemoteView },
  { path: REMOTE_PATHS.UNIVERSAL, component: UniversalRemotes },
  { path: REMOTE_PATHS.ADD_BLASTER, component: SelectBlaster },
  { path: REMOTE_PATHS.ADD_CATEGORY, component: ChooseCategory },
  { path: REMOTE_PATHS.ADD_BRAND, component: ChooseBrand },
  { path: REMOTE_PATHS.ADD_TEST, component: TestRemote },
];

export { RemotesList, RemoteView };
